import { render, staticRenderFns } from "./RecordItem.vue?vue&type=template&id=4fd06856&"
import script from "./RecordItem.vue?vue&type=script&lang=js&"
export * from "./RecordItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports